import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=53f75c19&scoped=true&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f75c19",
  null
  
)

/* custom blocks */
import block0 from "./LocaleSwitcher.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports